// extracted by mini-css-extract-plugin
export default {"price":"n5-z","onSale":"o5-z","msrpLabelPrice":"p5-z","msrpLabel":"q5-z","originalPrice":"r5-z","percentOff":"s5-z"};